/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ForgetPasswordAliases {
  AUTOCOMPLETE_DOCUMENT_TYPE = 'autocomplete-document-type',
  CONTENT_LAYOUT = 'content-layout',
  FETCH_DOCUMENT_TYPE = 'fetch-document-type',
  FIELD_0 = 'field-0',
  FIELD_CONFIRM_PASSWORD = 'field-confirm-password',
  FIELD_DOCUMENT_TYPE = 'field-document-type',
  FIELD_DS_CHAVE_SMS = 'field-ds-chave-sms',
  FIELD_IDENTIFICATION_TYPE = 'field-identification-type',
  FIELD_IDENTIFICATION_TYPE_VIEW = 'field-identification-type-view',
  FIELD_PASSWORD = 'field-password',
  FIELD_PASSWORD_VIEW = 'field-password-view',
  FIELD_PHYSICAL_PERSON_CODE = 'field-physical-person-code',
  FIELD_PHYSICAL_PERSON_CODE_VIEW = 'field-physical-person-code-view',
  FIELD_RECAPTCHA_EMAIL = 'field-recaptcha-email',
  FIELD_RECAPTCHA_SMS = 'field-recaptcha-sms',
  FIELD_RECOVERY_TYPES = 'field-recovery-types',
  FIELD_RECOVERY_TYPES_VIEW = 'field-recovery-types-view',
  FIELD_USERNAME = 'field-username',
  FIELD_USERNAME_VIEW = 'field-username-view',
  FIELD_VIEW_DS_CHAVE_SMS = 'field-view-ds-chave-sms',
  FORM_DS_CHAVE_SMS = 'form-ds-chave-sms',
  FORM_DS_CHAVE_SMS_VIEW = 'form-ds-chave-sms-view',
  FORM_RECOVERY_TYPE = 'form-recovery-type',
  FORM_RECOVERY_TYPE_VIEW = 'form-recovery-type-view',
  FORM_USERNAME = 'form-username',
  FORM_USERNAME_VIEW = 'form-username-view',
  INPUT_CONFIRM_PASSWORD = 'input-confirm-password',
  INPUT_DS_CHAVE_SMS = 'input-ds-chave-sms',
  INPUT_LOGIN = 'input-login',
  INPUT_PASSWORD = 'input-password',
  INPUT_PHYSICAL_PERSON_CODE = 'input-physical-person-code',
  INPUT_USERNAME = 'input-username',
  INPUT_VIEW_DS_CHAVE_SMS = 'input-view-ds-chave-sms',
  LAYOUT_FORGET_PASSWORD = 'layout-forget-password',
  LINK_RESEND_SMS = 'link-resend-sms',
  LOADER_0 = 'loader-0',
  LOADER_ACTION = 'loader-action',
  LOADER_SEND_SMS_CODE = 'loader-send-sms-code',
  LOADER_SUBMIT = 'loader-submit',
  LOGIN_WEB_LAB_FIELD = 'login-web-lab-field',
  MAPPER_DOCUMENT_TYPE = 'mapper-document-type',
  PANEL_0 = 'panel-0',
  PANEL_LINK_RESEND_CODE = 'panel-link-resend-code',
  PANEL_LOADER_ACTION = 'panel-loader-action',
  PANEL_LOADER_RESEND_SMS_CODE = 'panel-loader-resend-sms-code',
  PANEL_LOADER_SUBMIT = 'panel-loader-submit',
  PANEL_TEXT_INFORMATION_RESEND_SMS = 'panel-text-information-resend-sms',
  PASSWORD_CONFIRM_INPUT = 'password-confirm-input',
  PASSWORD_CONFIRM_WEB_LAB_FIELD = 'password-confirm-web-lab-field',
  PASSWORD_FORM = 'password-form',
  PASSWORD_FORM_VIEW = 'password-form-view',
  PASSWORD_INPUT = 'password-input',
  PASSWORD_WEB_LAB_FIELD = 'password-web-lab-field',
  RECAPTCHA_EMAIL = 'recaptcha-email',
  RECAPTCHA_SMS = 'recaptcha-sms',
  RG_IDENTIFICATION_TYPE = 'rg-identification-type',
  RG_RECOVERY_TYPES = 'rg-recovery-types',
  ROOT_LAYOUT = 'root-layout',
  ROOT_MODAL = 'root-modal',
  TEXT_IDENTIFICATION_TYPE = 'text-identification-type',
  TEXT_INFORMATION_RESEND_SMS_CODE = 'text-information-resend-sms-code',
  TEXT_PHYSICAL_PERSON_CODE_VIEW = 'text-physical-person-code-view',
  TEXT_RECOVERY_TYPE_VIEW = 'text-recovery-type-view',
  TEXT_USERNAME_VIEW = 'text-username-view',
  WZ_FORGET_PASSWORD = 'wz-forget-password',
  WZ_NEW_PASSWORD = 'wz-new-password',
  WZ_RECOVERY_TYPE = 'wz-recovery-type',
  WZ_STEP_USERNAME = 'wz-step-username',
  WZ_VERIFICATION_CODE = 'wz-verification-code',
}
export { ForgetPasswordAliases };
